import { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  IconButton,
  Button,
} from "@mui/material";
import { Box } from "@mui/material";
import ProgressCom from "../../components/ProgressCom";
import CustomPagination from "../../components/CustomPagination";
import { DataGrid, faIR } from "@mui/x-data-grid";
import ClearIcon from "@mui/icons-material/Clear";
import { UseProductCluster } from "./UseProductCluster";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import DeleteRow from "../../components/DeleteRow";
import DeleteIcon from "@mui/icons-material/Delete";
import { rsProgress } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import { useSnackbar } from "notistack";
import SearchComOff from "../../ContentManagement/firstPage/HomeOffer/SearchComOff";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

export default function ClusterProduct(props) {
  const { enqueueSnackbar } = useSnackbar();
  const [progress, setProgress] = useRecoilState(rsProgress);
  const { addclusterProduct } = UseProductCluster();
  const [pageState, setPageState] = useState({
    page: 1,
  });
  const [addUser, setAddUser] = useState(false);
  const [stateAdd, setStateAdd] = useState({
    id: props.ClusterID,
    productID: "",
  });

  const [deleteState, setDeleteState] = useState({
    show: false,
    name: undefined,
    id: undefined,
  });

  const columns = [
    {
      field: "id",
      width: 80,
      align: "center",
      headerName: "id",
      headerAlign: "center",
      sortable: false,
      hide: true,
    },
    {
      field: "rowIndex",
      width: 70,
      align: "center",
      headerName: "ردیف",
      headerAlign: "center",
      sortable: false,
    },
    {
      field: "productID",
      width: 90,
      align: "center",
      headerName: "کد محصول",
      headerAlign: "center",
      sortable: false,
    },
    {
      field: "title",
      width: 230,
      align: "center",
      headerName: "نام محصول",
      headerAlign: "center",
      sortable: false,
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.title}
          </Typography>
        );
      },
    },
    {
      field: "حذف",
      sortable: false,
      width: 80,
      headerAlign: "center",
      align: "center",
      headerName: "حذف",
      renderCell: (cellValues) => {
        return (
          <IconButton
            onClick={() => {
              setDeleteState({
                show: true,
                name: cellValues.row.title,
                id: cellValues.row.id,
              });
            }}
          >
            <DeleteIcon sx={{ color: "MyColor.main" }} />
          </IconButton>
        );
      },
    },
    {
      field: "addUser",
      width: 60,
      align: "center",
      headerAlign: "center",
      sortable: false,
      renderHeader: (cellValues) => {
        return (
          <IconButton
            onClick={() => {
              setAddUser(true);
            }}
          >
            <AddCircleIcon sx={{ color: "primary.main" }} />
          </IconButton>
        );
      },
    },
  ];

  return (
    <Dialog
      PaperProps={
        {
          // elevation: 1,
        }
      }
      sx={{ zIndex: 200 }}
      fullWidth
      open={props.showProducts}
      onClose={() => props.setShowProducts(false)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle
        sx={{ p: 1, px: 2 }}
        color="secondary"
        id="alert-dialog-title"
      >
        <Box
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          {!addUser ? (
            <Typography color="secondary" variant="subtitle2">
              لیست محصولات
            </Typography>
          ) : (
            <Typography variant="subtitle2">محصول را انتخاب کنید</Typography>
          )}
          {!addUser ? (
            <IconButton
              onClick={() => {
                props.setShowProducts(false);
              }}
            >
              <ClearIcon fontSize="small" />
            </IconButton>
          ) : (
            <IconButton
              onClick={() => {
                setAddUser(false);
              }}
            >
              <ArrowBackIcon fontSize="small" />
            </IconButton>
          )}
        </Box>
      </DialogTitle>
      <DialogContent>
        {!addUser ? (
          <Box sx={{ height: "18rem" }}>
            {props.rows ? (
              <DataGrid
                className="ltr-grid"
                localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
                columns={columns}
                rows={props.rows ? props.rows : []}
                page={pageState.page - 1}
                pageSize={20}
                Pagination
                onPageChange={(newPage) => {
                  setPageState((old) => ({ ...pageState, page: newPage + 1 }));
                }}
                rowCount={
                  props.rows && props.rows.length ? props.rows.length : 1
                }
                disableColumnMenu
                hideFooterSelectedRowCount
                components={{
                  Pagination: CustomPagination,
                }}
                componentsProps={{
                  pagination: {
                    nofab: true,
                    noPageCount: true,
                    rowCount:
                      props.rows && props.rows.length ? props.rows.length : "",
                    isLtr: true,
                  },
                }}
                initialState={{
                  sorting: {
                    sortModel: [
                      {
                        field: "id",
                        sort: "asc",
                      },
                    ],
                  },
                }}
              />
            ) : (
              <ProgressCom></ProgressCom>
            )}
          </Box>
        ) : (
          <Box
            sx={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              mt: 1,
            }}
          >
            <SearchComOff
              codeProduct
              productID={stateAdd.productID}
              productModel={stateAdd}
              setProductModel={setStateAdd}
            />
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                mt: 3,
              }}
            >
              <Button
                variant="contained"
                sx={{ mr: 2 }}
                onClick={() => {
                  if (!stateAdd.productID) {
                    enqueueSnackbar("محصول را انتخاب کنید", {
                      variant: "error",
                      autoHideDuration: 2000,
                      preventDuplicate: true,
                    });
                    return;
                  }
                  setProgress(true);
                  addclusterProduct(stateAdd, () => {
                    props.callback(props.ClusterID);
                    setAddUser(false);
                    setStateAdd({ ...stateAdd, productID: "" });
                  });
                }}
                onKeyDown={(event) => {
                  if (event.key === "Enter") {
                    if (!stateAdd.productID) {
                      enqueueSnackbar("محصول را انتخاب کنید", {
                        variant: "error",
                        autoHideDuration: 2000,
                        preventDuplicate: true,
                      });
                      return;
                    }
                    setProgress(true);
                    addclusterProduct(stateAdd, () => {
                      props.callback(props.ClusterID);
                      setAddUser(false);
                      setStateAdd({ ...stateAdd, productID: "" });
                    });
                  }
                }}
              >
                ثبت
              </Button>
              <Button
                onClick={() => props.setShowProducts(false)}
                color="secondary"
                variant="outlined"
              >
                انصراف
              </Button>
            </Box>
          </Box>
        )}
        <DeleteRow
          deleteState={deleteState}
          setDeleteState={setDeleteState}
          type={"محصول"}
          callback={() => {
            props.deleteCallback(deleteState.id);
          }}
        ></DeleteRow>
      </DialogContent>
    </Dialog>
  );
}
